import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import colours from '../../../tokens/colours';
import baseStyles from '../../../atoms/styles/baseStyles';
import useManagedField from '../queries/useManagedField';
import LegendButton from './LegendButton';
import MenuOption, { OPTION_HEIGHT } from './MenuOption';
import Feedback from '../../Feedback';
const getStyles = createUseStyles({
    ...baseStyles,
    root: {
        position: 'relative'
    },
    menu: {
        marginTop: 4,
        borderRadius: 4,
        backgroundColor: colours.septernary,
        overflow: 'hidden',
        position: 'absolute',
        left: 0,
        right: 0,
        transition: ['height', '0.1s', 'linear'],
        transitionDelay: '0.1s',
        boxShadow: ['#eaedf5', 0, 3, 10]
    },
});
const Select = ({ className, labelText, defaultValue, onChange, isError = false, options }) => {
    const startingValue = defaultValue || options[0].value;
    const [value, setValue] = useState(startingValue);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const onInputClick = (event) => {
        setValue(event.currentTarget.value);
        setIsMenuOpen(false);
        onChange(event);
    };
    const styles = getStyles();
    return (React.createElement("fieldset", { className: classNames(styles.root, className) },
        React.createElement(LegendButton, { onClick: () => setIsMenuOpen(!isMenuOpen), onBlur: () => setIsMenuOpen(false), isMenuOpen: isMenuOpen, labelText: labelText, isError: isError }, options.find(option => option.value === value).label),
        React.createElement("div", { className: classNames(styles.menu), style: { height: isMenuOpen ? options.length * OPTION_HEIGHT : 0 } }, options.map(data => React.createElement(MenuOption, { key: data.value, value: data.value, checked: data.value === startingValue, onClick: onInputClick }, data.label)))));
};
const ManagedSelect = (props) => {
    const { defaultValue } = props;
    const { meta: { error, isTouched, isValidating }, inputProps, setValue, } = useManagedField(props);
    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);
    const isError = !isValidating && isTouched && error;
    return (React.createElement(React.Fragment, null,
        isError && (React.createElement(Feedback, { type: 'error' }, error)),
        React.createElement(Select, { ...inputProps, defaultValue: defaultValue, isError: isError })));
};
Select.Managed = ManagedSelect;
export default Select;
//# sourceMappingURL=Select.js.map